import { cn } from "@/shared/lib/utils";
import { Loader2Icon } from "lucide-react";

export function Loader({ className }: { className?: string }) {
  return (
    <div className="flex min-h-40 w-full items-center justify-center p-6">
      <Loader2Icon
        className={cn("size-6 animate-spin text-muted-foreground", className)}
      />
    </div>
  );
}
